function getValue(value) {
    return value || null;
}

export default function(booking) {
    return {
        free: {
            date: getValue(booking?.free_cancel_date),
            time: getValue(booking?.free_cancel_date_raw),
        },
        no: {
            date: getValue(booking?.no_cancel_date),
            time: getValue(booking?.no_cancel_date_raw),
        },
        no_refund: {
            value: getValue(booking?.no_refund),
        },
        penalty: {
            date:  getValue(booking?.penalty_cancel_date),
            time:  getValue(booking?.penalty_cancel_date_raw),
            price: getValue(booking?.penalty_cancel_price),
        },
    };
};
